import { Box, Divider } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { ImageEmpty } from "@mzc-cloudplex/icons";
import Typography from "@components_v2/typography/typography";
import { useTranslation } from "react-i18next";

const EmptyList = ({ domain, additionalText }) => {
    const { t } = useTranslation();

    return (
        <>
            <Divider
                orientation={"horizontal"}
                className={"flat"}
                sx={{
                    width: `100%`,
                    borderColor: `${theme.palette.secondary[100]}`,
                }}
            />
            <Box
                sx={{
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    width: `100%`,
                    flex: `1`,
                    paddingTop: "5%",
                    paddingBottom: "5%",
                }}
            >
                <Box
                    sx={{
                        display: `flex`,
                        flexDirection: `column`,
                        alignItems: `center`,
                        justifyContent: `center`,
                        width: `400px`,
                        height: `400px`,
                        textAlign: `center`,
                    }}
                >
                    <ImageEmpty width={76} height={70} />
                    <Typography variant={`subtitle1_700`} component={"p"} gutterBottom sx={{ marginTop: `20px` }}>
                        {domain ? t(`common::msg::No ${domain} items yet.`) : t(`common::msg::No items yet.`)}
                    </Typography>
                    {additionalText && (
                        <Typography
                            variant={`body3bold`}
                            component={"p"}
                            sx={{
                                mt: 1,
                                color: theme.palette.secondary[600],
                            }}
                        >
                            {additionalText}
                        </Typography>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default EmptyList;
